import { queryDpMessage } from '@tencent/wphk-components-dp-loader';
import { CustomException } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';
import { DpItem, QryDpMsgRes } from '@tencent/wphk-components-dp-loader/src/types';

/** 获取投放计划 */
export async function queryInfoFromDp(dpPage: string, dpPositions: string[]): Promise<DpItem[]> {
  // 从投放中台查询信息
  const [error, dpMsg] = await to(queryDpMessage({ dpPage, dpPositions }));
  if (error || !dpMsg) {
    new CustomException(error, 'DpLoaderException', `loader failed for dpPage: ${dpPage}, dpPosition: ${dpPositions}`);
    return [];
  }
  return (dpMsg as QryDpMsgRes)?.dpList || [];
}
